<template>
  <svg class="icon"
       width="18"
       height="18"
       viewBox="0 0 18 18"
       fill="currentColor"
       xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 4.0275 4.0275 0 9 0C13.9725 0 18 4.0275 18 9C18 13.9725 13.9725 18 9 18C4.0275 18 0 13.9725 0 9ZM9 11.4975C6.93 11.4975 5.1075 13.365 4.995 15.525C6.165 16.245 7.5375 16.65 9 16.65C10.4625 16.65 11.835 16.245 13.005 15.525C12.87 13.3425 11.07 11.4975 9 11.4975ZM9 9.81818C10.3556 9.81818 11.4545 8.71924 11.4545 7.36364C11.4545 6.00803 10.3556 4.90909 9 4.90909C7.64439 4.90909 6.54545 6.00803 6.54545 7.36364C6.54545 8.71924 7.64439 9.81818 9 9.81818Z" />
  </svg>
</template>

<script>
export default {
  name: 'Patient',
};
</script>
